import { useCallback, useMemo } from 'react';

import { VacanciesRoute } from '../../../../routers/AppRouter/routes';
import { VacancyTo } from '../../../../types/routes.types';
import { useToggles } from '../../../useToggles';
import { useGetJobId } from '../../useGetJobId';
import { useAutoRedirect } from '../useAutoRedirect';

export const useAutoRedirectVacancyDetails = (): void => {
  const jobId = useGetJobId();
  const {
    features: { HB5540_new_vacancy_details },
  } = useToggles();
  const redirectCondition = useCallback(
    () => !!jobId && HB5540_new_vacancy_details,
    [jobId, HB5540_new_vacancy_details]
  );
  const redirectRoute: VacancyTo = useMemo(
    () => ({ pathname: VacanciesRoute.VACANCY_DETAILS, queryParams: { job: jobId || '' } }),
    [jobId]
  );

  useAutoRedirect(redirectRoute, redirectCondition);
};
